import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import about from '../assests/about/about.webp';
import about1 from '../assests/about/about1.webp';
import about2 from '../assests/about/about2.webp';
import about3 from '../assests/about/about3.webp';
import about4 from '../assests/about/about4.webp';
import about5 from '../assests/about/about5.webp';
import about6 from '../assests/about/about6.webp';
import about7 from '../assests/about/about7.webp';
import about8 from '../assests/about/about8.webp';
import about9 from '../assests/about/about9.webp';


const AboutUs = () => {
  const carouselImages = [
     about,about1,about2,about3,about4,about5,about6,about7,about8,about9
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    pauseOnHover: true,
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-black via-gray-900 to-black overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-20 w-96 h-96 bg-red-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-amber-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse animation-delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-72 h-72 bg-purple-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse animation-delay-2000"></div>
      </div>

      {/* Film Strip Border Effect */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-red-600 via-amber-500 to-red-600"></div>
      <div className="absolute bottom-0 left-0 w-full h-2 bg-gradient-to-r from-red-600 via-amber-500 to-red-600"></div>

      {/* Main Content */}
      <div className="relative z-10 flex items-center justify-center min-h-screen px-6 py-20">
        <div className="max-w-6xl mx-auto">
          {/* Header Section */}
          <div className="text-center mb-16">
            <div className="inline-block mb-6">
              <div className="relative">
                <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold bg-gradient-to-r from-red-500 via-amber-400 to-red-500 bg-clip-text text-transparent mb-4 tracking-tight">
                  OUR STORY
                </h1>
                <div className="absolute -inset-1 bg-gradient-to-r from-red-600 to-amber-500 rounded-lg blur opacity-25"></div>
              </div>
            </div>
            <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-amber-500 mx-auto mb-8"></div>
            <p className="text-xl md:text-2xl text-gray-300 font-light leading-relaxed max-w-4xl mx-auto">
              Where cinematic dreams become reality
            </p>
          </div>

          {/* Story Content */}
          <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
            {/* Vision */}
            <div className="backdrop-blur-sm bg-white/5 rounded-2xl p-8 border border-white/10 hover:border-red-500/30 transition-all duration-500 hover:transform hover:scale-105">
              <h3 className="text-2xl font-bold text-white mb-4 flex items-center">
                <span className="w-3 h-3 bg-red-500 rounded-full mr-3 animate-pulse"></span>
                The Vision
              </h3>
              <p className="text-gray-300 leading-relaxed">
                Grand Cinemaz was born from a dream to bring world-class cinema
                to the heart of Himachal Pradesh. What started as a bold vision
                has evolved into a premium entertainment experience offering
                cutting-edge technology and unmatched comfort.
              </p>
            </div>

            {/* Journey */}
            <div className="backdrop-blur-sm bg-white/5 rounded-2xl p-8 border border-white/10 hover:border-amber-500/30 transition-all duration-500 hover:transform hover:scale-105">
              <h3 className="text-2xl font-bold text-white mb-4 flex items-center">
                <span className="w-3 h-3 bg-amber-500 rounded-full mr-3 animate-pulse"></span>
                The Journey
              </h3>
              <p className="text-gray-300 leading-relaxed">
                From humble beginnings, our journey has been fueled by
                innovation, passion, and a deep commitment to redefining how
                people experience movies. This is more than just a multiplex —
                it's a cultural shift designed to bring the joy of cinema closer
                to communities across the region.
              </p>
            </div>
          </div>

          {/* Corporate Bookings Section */}
          <div className="mb-20">
            <h2 className="text-center text-4xl font-bold text-white mb-10 bg-gradient-to-r from-red-500 via-amber-400 to-red-500 bg-clip-text text-transparent">
              Corporate & School Bookings
            </h2>
            <div className="grid md:grid-cols-2 gap-12 items-center">
              {/* Text */}
              <div className="backdrop-blur-sm bg-white/5 rounded-2xl p-8 border border-white/10 hover:border-purple-500/30 transition-all duration-500 hover:transform hover:scale-105">
                <h3 className="text-2xl font-bold text-white mb-4">
                  Private Shows & Group Bookings
                </h3>
                <p className="text-gray-300 leading-relaxed">
                  Whether it’s a school field trip, college movie day, or a
                  corporate celebration — we offer custom booking packages to
                  make your group experience seamless and special.
                </p>
              </div>

              {/* Carousel */}
              <div className="rounded-2xl overflow-hidden border border-white/10 hover:border-white/20 transition-all duration-500 shadow-lg">
                <Slider {...settings}>
                  {carouselImages.map((src, i) => (
                    <div key={i} className="h-64 md:h-80 w-full">
                      <img
                        src={src}
                        alt={`Slide ${i + 1}`}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>

          {/* Call to Action */}
        </div>
      </div>

      {/* Floating Particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-red-500 rounded-full animate-ping opacity-20"></div>
        <div className="absolute top-3/4 right-1/4 w-3 h-3 bg-amber-500 rounded-full animate-ping opacity-20 animation-delay-1000"></div>
        <div className="absolute bottom-1/4 left-1/3 w-2 h-2 bg-purple-500 rounded-full animate-ping opacity-20 animation-delay-2000"></div>
      </div>
    </div>
  );
};

export default AboutUs;
